module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/core-js/modules/_fails.js
// module id = 13
// module chunks = 2 3 4 5 6 7 8 9 10 11 12